export type ActivityHistoryNavigationRequest = {
  proceed: () => void;
};

type ActivityHistoryNavigationHandler = (request: ActivityHistoryNavigationRequest) => void;

let dirty = false;
let restoring = false;
let pendingRequest: ActivityHistoryNavigationRequest | null = null;
let requestHandler: ActivityHistoryNavigationHandler | null = null;
let currentHistoryIndex = historyIndex(window.history.state);

window.addEventListener("popstate", (event) => {
  const nextHistoryIndex = historyIndex(event.state);

  if (restoring) {
    restoring = false;
    currentHistoryIndex = nextHistoryIndex;
    event.stopImmediatePropagation();
    const request = pendingRequest;
    pendingRequest = null;
    if (request) requestHandler?.(request);
    return;
  }

  if (!dirty || !requestHandler) {
    currentHistoryIndex = nextHistoryIndex;
    return;
  }

  const restoreDelta = currentHistoryIndex - nextHistoryIndex;
  if (restoreDelta === 0) {
    currentHistoryIndex = nextHistoryIndex;
    return;
  }

  event.stopImmediatePropagation();
  restoring = true;
  pendingRequest = {
    proceed: () => {
      dirty = false;
      window.history.go(-restoreDelta);
    },
  };
  window.history.go(restoreDelta);
});

export function registerActivityHistoryNavigationHandler(
  handler: ActivityHistoryNavigationHandler,
): () => void {
  requestHandler = handler;
  return () => {
    if (requestHandler === handler) requestHandler = null;
  };
}

export function setActivityNavigationDirty(value: boolean): void {
  dirty = value;
  if (value) currentHistoryIndex = historyIndex(window.history.state);
}

function historyIndex(state: unknown): number {
  if (typeof state !== "object" || state === null || !("idx" in state)) return 0;
  const index = (state as { idx?: unknown }).idx;
  return typeof index === "number" ? index : 0;
}
